import React, { useState } from 'react';
import { Grid, Card, CardContent, Typography, InputBase, List, ListItem, ListItemText,TextField, Button, Box, Chip, Paper, Select } from '@mui/material';
import JobOrderForm from './createJobOrder';
import Modal from '@mui/material/Modal';
import HeightBox from '../../components/HeightBox';
import { useSelector,useDispatch } from 'react-redux';
import Switch from '@mui/material/Switch';
import { makeStyles } from '@mui/styles';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Divider from '@mui/material/Divider';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { getAllJobOrders,updateJobOrderCandidate } from './services';
import UserProfileContainer from '../hunting/view/profile';
import CandidateService from '../../services/candidateService';
import { selectRegNumber, setSelectedURLs } from '../../actions/fileActions';
import { getJobOrdersAction } from './actions';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import FavoriteIcon from '@mui/icons-material/Favorite';
import NavigationIcon from '@mui/icons-material/Navigation';
import { set } from 'date-fns';
import DetailsComponent from '../jobOrders/details';
import UpdateJobOrderForm from './updateJobOrder';
import FileCards from '../../containers/Forms/FileCard';
import MenuItem from '@mui/material/MenuItem';

const styles = {
  select: {
    width: '100%',
    padding: '2px',
    marginBottom: '4px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '14px',
    backgroundColor: '#fff',
  },
};

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: theme.spacing(2),
  },
  selectedJobOrder: {
    backgroundColor: theme.palette.primary.light, // Change to the desired background color
    color: theme.palette.primary.contrastText, // Change to the desired text color
    borderRadius: 10,
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(2),
  },
  jobOrder:{
    backgroundColor:'#f0f0f0', // Change to the desired background color
    borderRadius: 10,
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(2),
  },
  searchBox: {
    marginBottom: theme.spacing(2),
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#f0f0f0',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
}));

const LeftCard = ({ handleJobOrderSelect }) => {
  const dispatch=useDispatch();
  const jobOrderState=useSelector((state)=>state.jobOrder.jobOrders);

  const [jobOrders,setJobOrders] = useState([
    { id: 1, title: 'Job Order 1' },
    { id: 2, title: 'Job Order 2' },
    { id: 3, title: 'Job Order 3' }]);
  
  const [loading,setLoading]=useState(false);

  React.useEffect(() => {
    setLoading(true);
    dispatch(getJobOrdersAction());
    setJobOrders(jobOrderState);
    setLoading(false);
  }, []);

  React.useEffect(()=>{
    setJobOrders(jobOrderState)
  },[jobOrderState])

  const [searchText, setSearchText] = useState('');
  const [selectedJobOrder, setSelectedJobOrder] = useState(null);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const filteredJobOrders = jobOrders.filter((jobOrder) => {
    const { id,profession } = jobOrder;
    const searchTerm = searchText.toLowerCase();
    return (
      id?.toString().toLowerCase().includes(searchTerm) ||
      profession?.toLowerCase().includes(searchTerm) 
    );
  });

  const classes = useStyles();

  React.useEffect(() => {
    handleJobOrderSelect(selectedJobOrder)
  }, [selectedJobOrder]);
  
  
  return (
    <Card style={{height:'85vh'}}>
      <CardContent>
        <Typography variant="h5" component="div" gutterBottom>
         Job Orders
        </Typography>
        <List>
        <div className={classes.searchBox}>
          <InputBase
            placeholder="Search..."
            className={classes.input}
            value={searchText}
            onChange={handleSearchChange}
          />
        </div>
        <div style={{ overflowY:'scroll',height:'80vh',paddingRight:'10px'}}>
        {!loading &&
        filteredJobOrders.map((jobOrder) => (
          
        <div key={jobOrder.id } 
        style={{
          padding:4,
          backgroundColor:jobOrder.id===selectedJobOrder?.id?'#f0f0f0':'#ffffff',
          borderRadius:10, 
          borderLeft:jobOrder.id===selectedJobOrder?.id?'solid 4px #3f51b5':'solid 2px #ffffff',
          cursor:'pointer',
          marginBottom:4 
        }}

        onClick={() => setSelectedJobOrder(jobOrder)}>
         <Typography variant="body2" style={{fontSize:'10px',fontWeight:'bold'}} component="div">
              {"Job ID: " + jobOrder.id}
          </Typography>
          <div>
              <Typography variant="body2" style={{fontSize:'12px'}} component="div" >
                <strong>Profession:</strong> {jobOrder.profession}
              </Typography>
              <Typography variant="body2" style={{fontSize:'12px'}} component="div">
                <strong>Quantity:</strong> {jobOrder.quantity}
              </Typography>
            </div>
        </div>
        )) 
        }
        {loading && <div>Loading...</div>}
        </div>
        </List>
      </CardContent>
    </Card>
  );
};



const RightCard = ({ selectedJobOrder }) => {

  const classes = useStyles();
   //dialogbox
    
   const [dialogOpen, setDialogOpen] = useState(false);
   const [selectedEmployeeNumber, setSelectedEmployeeNumber] = useState(null);
   const [formValues, setFormValues] = useState({});
   const [files, setFiles] = useState([]);
   const dispatch = useDispatch();

   const handleOpenDialog = (employeeNumber) => {
    setDialogOpen(true);
   };
 
   const handleCloseDialog = () => {
     setDialogOpen(false);
   };

  const [employees, setEmployees] = useState([]);
  
  React.useEffect(() => {
    setEmployees(selectedJobOrder?.JobOrderCandidates);
  }, [selectedJobOrder]);

  const fetchFiles = async () => {
    try {
      const user = localStorage.getItem('user');
      const token = JSON.parse(user).data.token;
      const response = await fetch(`https://oseas-api.hypen.lk/api/v1/candidates/files/1`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        }
      });

      if (response.ok) {
        // Request successful
        const data = await response.json();
        console.log(data);
        setFiles(data);

      } else {
        // Request failed
        console.error('Request failed:', response.status);
      }
    } catch (error) {
      console.error('Request failed:', error.message);
    }
  };

  const [newFiles, setNewFiles] = useState([])

  // useEffect(() => {
  //   getNewFile(jobOrder.id);
  // }, [jobOrder.id]);

  const getNewFile = async (nic) => {
    console.log(nic)
    try {
      const res = await CandidateService.getNewFiles(nic,'jobOrder');
      console.log(res.data)
      if(res?.data?.length >0){
        setNewFiles(res.data);
      }else{
        setFiles([])
      }

    } catch (error) {
      alert("Error getting files");
    }
  };

  React.useEffect(() => {
    if (selectedJobOrder) {
      getNewFile(selectedJobOrder?.id,'jobOrder');  
    }
  }, [selectedJobOrder]);

  const handleViewProfile = async (candidate) => {
    setFormValues(candidate);
    console.log('searching');
    dispatch(setSelectedURLs([]));
    await fetchFiles();
    dispatch(selectRegNumber(candidate.regNumber));
    
    handleOpenDialog(candidate.employeeNumber);
  };

  const handleAddToSelectionPool = async (employeeId) => {
    console.log('Add employee with id: ' + employeeId + ' to selection pool');
  };
  const label = { inputProps: { 'aria-label': 'Switch demo' } };

  const [toggleCardVisibility, setToggleCardVisibility] = useState(true);

  const handleSelectCandidate = (employeeId) => {
    console.log('Select employee with id: ' + employeeId);
    updateJobOrderCandidate(employeeId, {"status": "Selected"}).then((res) => {
      console.log(res.data);
      alert('success');
      // Update the status of the selected employee
      setEmployees(employees.map((employee) => {
        if (employee.id === employeeId) {
          employee.status = "Selected";
        }
        return employee;
      }));
    });
  };

  const handleHireCandidate = (employeeId) => {
    console.log('Select employee with id: ' + employeeId);
    updateJobOrderCandidate(employeeId, {"status": "Hired"}).then((res) => {
      console.log(res.data);
      alert('success');
      // Update the status of the selected employee
      setEmployees(employees.map((employee) => {
        if (employee.id === employeeId) {
          employee.status = "Hired";
        }
        return employee;
      }));
    });
    //update candidate profile as hired
  };
  
  const handleUpdateStatus = (employeeId,status) => {
    console.log('Select employee with id: ' + employeeId);
    updateJobOrderCandidate(employeeId, {"status": status}).then((res) => {
      console.log(res.data);
      alert('success');
      // Update the status of the selected employee
      setEmployees(employees.map((employee) => {
        if (employee.id === employeeId) {
          employee.status = status;
        }
        return employee;
      }));
    });
  };

  const handleRejectCandidate = (employeeId) => {
    console.log('Reject employee with id: ' + employeeId);
    updateJobOrderCandidate(employeeId, {"status": "Rejected"}).then((res) => {
      console.log(res.data);
      alert('success');
      // Update the status of this employee record
      setEmployees(employees.map((employee) => {
        if (employee.id === employeeId) {
          employee.status = "Rejected";
        }
        return employee;
      }));
    });
  };
  

  //schedule interview

  const [open, setOpen] = useState(false);
  const [interviewTitle, setInterviewTitle] = useState('');
  const [interviewDate, setInterviewDate] = useState('2023-08-01');
  const [interviewTime, setInterviewTime] = useState('08:00');
  const [interviewLocation, setInterviewLocation] = useState('');
  const [interviewData,setInterviewData]=useState({
    title:'',
    date:'',
    time:'',
    note:'',
    location:'',
    candidate:'',
    jobOrder:'',
  });

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [temp,setTemp]=useState({});

  const handleScheduleInterview = (jobOrder,employee) => {
    setTemp({
      candidate:employee
    })
    handleOpen();
  }

  const submitScheduleInterview = () => {
    // Validate inputs
    if (!interviewTitle || !interviewDate || !interviewTime) {
      // Show error message or perform validation logic
      return;
    }

  


    // Add the event to Google Calendar (you'll need to implement this logic)

    // Add the employee to the selection pool
    
    console.log(temp?.candidate?.extraFields);
    const extraFields = temp?.candidate?.extraFields;
    const interviewData={
      
      title:interviewTitle,
      date:interviewDate,
      time:interviewTime,
      note:'',
      location:interviewLocation,
      status:'Pending',
    }

    const newInterviews = [...(extraFields?.interviews || []), interviewData];
    const newExtraFields = {
      ...extraFields,
      interviews: newInterviews
    };
    
    console.log(newExtraFields);
    
    
    console.log(newExtraFields);
    
    //update job order list employee field
    updateJobOrderCandidate(temp?.candidate?.id, {"extraFields": newExtraFields}).then((res) => {
      console.log(res.data);
      alert('success');
      const employeeId=temp?.candidate?.id;
      // Update the status of the selected employee
      setEmployees(employees.map((employee) => {
        if (employee.id === employeeId) {
          employee.extraFields = newExtraFields;
        }
        return employee;
      }));
    });

    // Close the dialog
    handleClose();
  };

  const [openUpdateDialog, setOpenUpdateDialog] = useState(false);
  
  const handleUpdateDialogOpen = () => {
    setOpenUpdateDialog(true);
  };

  const handleUpdateDialogClose = () => {
    setOpenUpdateDialog(false);
    dispatch(getJobOrdersAction());
  };

  const statusOptions = [
    "Documentation Process",
    "Medical Process - Pre Medical",
    "Medical Process - Post Medical",
    "Visa Process",
    "SLBFE Process",
    "Deployment Process"
  ];

  return (
    <>
    <Card style={{height:'85vh',overflowY:'scroll'}}>
      

      
      <div>
      <Modal open={openUpdateDialog} onClose={handleUpdateDialogClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            height:'100%',
            overflow:'scroll',
            width:'70%',
            left: '60%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
          }}
        >
          <UpdateJobOrderForm jobOrder={selectedJobOrder} handleClose={handleUpdateDialogClose} />
        </Box>
      </Modal>
    </div>

       <Accordion  style={{ position: 'sticky', top: 0,opacity:0.9, zIndex: 1 }}>
        
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
           <Typography variant="subtitle1" gutterBottom>
              Job Order Details
              <Chip label={"Found " + employees?.length + " Recommended Candidates"} style={{ marginTop:'4px',marginLeft:'20px',marginRight: '0.5rem', marginBottom: '0.5rem' }} />

            </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <CardContent style={{background:'white',borderRadius:10}}>
          <Button
        variant="contained"
        size="small"
        color="primary"
        onClick={() => handleUpdateDialogOpen()}
        style={{backgroundColor:'#37b6ff', marginBottom: '0.5rem',fontSize:'12px' }}
      >
        Update 
      </Button>

      <FileCards files={newFiles} />
          {selectedJobOrder ? (
            <DetailsComponent details={selectedJobOrder} />
          ) : (
            <Typography variant="body1" gutterBottom>
              No job order selected.
            </Typography>
          )}
          </CardContent>
        </AccordionDetails>
      </Accordion>

       

    
        <CardContent style={{overflowY:'scroll',height:'100%'}}>
          {/* <Typography variant="h5" component="div" gutterBottom>
            Recommended candidates
            </Typography> */}
            <Grid item xs={12}>
          <Grid  container spacing={2}>
            <Grid item xs={12} >
            
            {employees?.map((employee) => (
              <Grid item xs={12} key={employee.id} style={{paddingTop:0,paddingBottom:10}}>
                <Paper
                    style={{
                      padding: '1rem',
                      marginRight: '1rem',
                      background: '#f7fbff',
                      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                      borderRadius: '4px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Grid container spacing={2}>
                      {/* <Grid item xs={1}>
                        <div>
                        <Avatar
                          alt='Employee Profile Picture'
                          // src={employee.profilePicture}
                          style={{ width: '3rem', height: '3rem',alignSelf:'center' }}
                        />
                        </div>
                      </Grid> */}
                      <Grid item xs={8}>
                        <div>
                          <Typography variant="h4" style={{fontSize:16,letterSpacing: '1px',fontWeight:'bold' }}>
                            {employee?.candidate?.fullName}
                          </Typography>                          
                          <HeightBox height={5}/>

                          <Typography variant="body2" style={{ marginBottom: '0.5rem',letterSpacing: '1px',fontSize:12 }}>
                            <strong>Salary Expectation: </strong> 
                            
                            {employee?.candidate?.personalInfo?.expectedSalaryPackage && (
                          <span>
                            {employee?.candidate?.personalInfo?.expectedSalaryPackageCurrency}{' '}
                            {Number(employee?.candidate?.personalInfo.expectedSalaryPackage).toLocaleString('en-US', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </span>
                          )}

                            | <strong> Applied Role:</strong> {employee?.candidate?.personalInfo?.appliedPosition} <br></br>
                              <strong> Availability : {employee?.candidate?.availability}</strong> {employee?.candidate?.location}
                          </Typography>
                         
                          <Typography variant='body2' style={{fontSize:12 }} >
                            Years Of Experience : {employee?.candidate?.personalInfo?.totalYearsOfExperience}
                            </Typography>
                            <Typography variant='body2' style={{ marginBottom: '0.5rem',fontSize:12 }} >
                            {employee?.candidate?.personalInfo?.professionalSummary}
                            </Typography>
                          <HeightBox height={2}/>
                          <div>
                            {employee?.candidate?.skills?.map((skill, index) => (
                              <Chip
                                key={index}
                                label={skill}
                                style={{ marginRight: '0.5rem', marginBottom: '0.5rem' }}
                              />
                            ))}
                          </div>
                          <div style={{background:'white',padding:4,margin:4,borderRadius:4,boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'}}>
                            {employee?.extraFields?.interviews &&
                            
                              employee.extraFields.interviews.map((interview, index) => (
                                <div key={index}>
                                  <Typography variant='body2' style={{ marginBottom: '0.5rem',fontSize:12 }} >
                                    <strong>Interview Title:</strong> {interview.title}
                                  </Typography>
                                  <Typography variant='body2' style={{ marginBottom: '0.5rem',fontSize:12 }} >
                                    <strong>Interview Date:</strong> {interview.date} | <strong>Interview Time:</strong> {interview.time} 
                                    | <strong>Interview Location:</strong> {interview.location}
                                  </Typography>
                                  <Divider/>
                                </div>
                                
                              ))
                            }
                          </div>
                          <div>
                            <Chip size='small' label={employee?.status} 
                            style={{ background: employee?.status==='Selected'? 'green':'blue',color:'white', marginRight: '0.5rem', marginBottom: '0.5rem' }} />
                          </div>
                        </div>
                      </Grid> 
                      <Grid item xs={3}>
                      
                      
                      <Grid item xs={12}>
                        <Button
                          variant="contained"
                          size="small"
                          color="primary"
                          fullWidth
                          onClick={() => handleViewProfile(employee.candidate)}
                          style={{backgroundColor:'#37b6ff', marginBottom: '0.5rem',fontSize:'12px' }}
                        >
                          Profile
                        </Button>
                      </Grid>

                      <Grid item xs={12}>
                      <Select
      style={styles.select}
      size="small"
      fullWidth
      value={employee.status}
      onChange={(event) => handleUpdateStatus(employee.id, event.target.value)}
    >
      {statusOptions.map((option, index) => (
        <MenuItem key={index} value={option}>
          {option}
        </MenuItem>
      ))}
    </Select>
</Grid>

  <Grid item xs={12}>
    <Button
      variant="contained"
      size="small"
      fullWidth
      style={{ backgroundColor: '#f1c40f', marginBottom: '0.5rem', fontSize: '12px', color: '#ffffff' }}
      onClick={() => handleScheduleInterview(selectedJobOrder, employee)}
    >
      Schedule Interview
    </Button>
  </Grid>

<Grid item xs={12}>
  <Button
    variant="contained"
    size="small"
    fullWidth
    disabled={employee?.status === 'Hired'}
    style={{ backgroundColor: 'red', fontSize: '12px', color: '#ffffff' }}
    onClick={() => handleRejectCandidate(employee.id)}
  >
    {employee?.status === 'Hired' ? 'Cannot Reject' : 'Reject'}
  </Button>
</Grid>

                      </Grid> 
                    </Grid>
                    
                   
                </Paper>
              </Grid>  
            ))}
            {!employees | employees?.length===0 ? 
              <>
              Stay in touch.We will recommend best candidates for your requirements as soon as possible.
              </> :<>
              
              </>
            }
            </Grid>
          </Grid>
            </Grid>
        </CardContent>
         </Card>

          
    <Dialog sx={{left:'10%'}} maxWidth='md' open={dialogOpen} onClose={handleCloseDialog}>
    <DialogTitle>Candidate Profile</DialogTitle>
    <DialogContent>
      {/* Content inside the dialog */}
      {/* <Typography variant="body1">
        Are you sure you want to recommend Employee {selectedEmployeeNumber}?
      </Typography> */}
      <UserProfileContainer data={formValues}/>
    </DialogContent>
    <DialogActions>
      {/* Actions buttons inside the dialog */}
      <Button onClick={handleCloseDialog} color="primary">
        Close
      </Button>
      {/* <Button onClick={handleCloseDialog} color="primary" variant="contained">
        Recommend
      </Button> */}
    </DialogActions>
    </Dialog>

   
    {/* Interview schedule Dialog */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Schedule Interview</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            label="Interview Title"
            size='small'
            value={interviewTitle}
            onChange={(e) => setInterviewTitle(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Interview Date"
            type="date"
            size='small'
            value={interviewDate}
            onChange={(e) => setInterviewDate(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Interview Time"
            type="time"
            size='small'
            value={interviewTime}
            onChange={(e) => setInterviewTime(e.target.value)}
            fullWidth
            margin="normal"
          />
           <TextField
            label="Location"
            type="text"
            size='small'
            value={interviewLocation}
            onChange={(e) => setInterviewLocation(e.target.value)}
            fullWidth
            margin="normal"
          />

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={submitScheduleInterview} color="primary">
            Schedule 
          </Button>
        </DialogActions>
      </Dialog>
  
    </>
  );
};

const JobOrders = () => {

  const [open, setOpen] = useState(false);
  const [leftCardKey, setLeftCardKey] = useState(0);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    console.log('close')
    setLeftCardKey(prevKey => prevKey + 1);
    setOpen(false);

  };

  const [selectedJobOrder, setSelectedJobOrder] = useState(null);

  const handleJobOrderSelect = (jobOrder) => {
    setSelectedJobOrder(jobOrder);
  };

  return (
    <Grid container spacing={2}>
    <Fab
    variant="extended"
    color="primary"
    onClick={handleOpen}
    style={{ position: 'fixed', bottom: '16px', right: '16px', zIndex: 9999 }}
  >
    <EditIcon sx={{ marginRight: '8px' }} />
    Place Job Order
  </Fab>
      <div>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            height:'100%',
            overflow:'scroll',
            width:'70%',
            left: '60%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
          }}
        >
          <JobOrderForm handleClose={handleClose} />
        </Box>
      </Modal>
    </div>
      <Grid item xs={3}>
      <LeftCard key={leftCardKey} handleJobOrderSelect={handleJobOrderSelect} />
      </Grid>
      <Grid item xs={9}>
     
        <RightCard selectedJobOrder={selectedJobOrder} />
      </Grid>
    </Grid>
  );
};

export default JobOrders;
